import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-y-4"
}

import type { BlockBaseElement, BlockHeading, BlockText } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";

interface TabsHeaderProps {
    title: BlockBaseElement<BlockHeading>;
    description: BlockBaseElement<BlockText>;
    titleTextColor: string;
    descriptionTextColor: string;
    blockId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TabsHeader',
  props: {
    title: {},
    description: {},
    titleTextColor: {},
    descriptionTextColor: {},
    blockId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!_ctx.title.isHidden || !_ctx.description.isHidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.title.isHidden)
          ? (_openBlock(), _createBlock(EditableElement, {
              key: 0,
              blockId: _ctx.blockId,
              fieldName: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(Heading, {
                  text: _ctx.title.data.text,
                  tag: _ctx.title.data.tag,
                  textColor: _ctx.titleTextColor,
                  class: "text-4xl"
                }, null, 8, ["text", "tag", "textColor"])
              ]),
              _: 1
            }, 8, ["blockId"]))
          : _createCommentVNode("", true),
        (!_ctx.description.isHidden)
          ? (_openBlock(), _createBlock(EditableElement, {
              key: 1,
              blockId: _ctx.blockId,
              fieldName: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(Paragraph, {
                  text: _ctx.description.data.text,
                  textColor: _ctx.descriptionTextColor,
                  class: "opacity-70"
                }, null, 8, ["text", "textColor"])
              ]),
              _: 1
            }, 8, ["blockId"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})